import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { MonthlyAttendanceReservationCount } from '@/types/attendanceReservation';

export const getMonthlyAttendanceCount = async (
  email: string,
  year: string,
  month: string
): Promise<ApiResult<MonthlyAttendanceReservationCount[]>> => {
  const searchParams = new URLSearchParams({
    email: email,
    year: year,
    month: month,
  });
  const { status, result } = await callApi<MonthlyAttendanceReservationCount[]>(
    `attendance-reservations/monthly-count`,
    'GET',
    searchParams,
    undefined,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
